import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import MVCard from '@/components/base/MVCard';
import { categories, getMVsByCategory } from '@/mocks/mvs';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryMVs = slug ? getMVsByCategory(slug) : [];

  const categoryName = currentCategory?.name || '全部';
  const categoryDesc = currentCategory?.description || '浏览全部欧美MV';

  const categorySchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryName}MV - 欧美MV大全`,
    description: categoryDesc,
    url: typeof window !== 'undefined' ? window.location.href : '',
    isPartOf: {
      '@type': 'WebSite',
      name: '欧美MV大全',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(categorySchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: `${categoryName}MV` },
            ]}
          />

          <section className="w-full px-4 md:px-6 py-6 md:py-10">
            <div className="max-w-7xl mx-auto">
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-white">
                    <i className={`${currentCategory?.icon || 'ri-music-line'} text-lg`}></i>
                  </div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {categoryName}MV
                  </h1>
                </div>
                <p className="text-sm md:text-base text-foreground-500">{categoryDesc}</p>
              </div>

              <div className="flex items-center gap-2 overflow-x-auto pb-4 mb-8 flex-wrap">
                <Link
                  to="/"
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                    !slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  全部
                </Link>
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                      slug === cat.slug
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>

              {categoryMVs.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5" data-product-shop>
                  {categoryMVs.map((mv) => (
                    <MVCard key={mv.id} mv={mv} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-4">
                    <i className="ri-music-2-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无MV，请浏览其他分类</p>
                  <Link
                    to="/"
                    className="inline-block mt-4 px-6 py-2 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    返回首页
                  </Link>
                </div>
              )}
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}